<template>
    <div
    >
        <v-row v-if="select === 'Fix'">
            <v-col cols="6" md="6" class="my-1">
                <div class="form-label mb-1" hide-details="auto">{{ $t('message.qualifiedApplicants.dialog.type')}}</div>
                <v-select
                    v-model="select"
                    dense
                    outlined
                    hide-details="auto"
                    :items="type_gen"
                    @change="select = 'Generate'"
                ></v-select>
            </v-col>
            <v-col cols="6" md="6" class="my-1">
                <v-row>
                    <v-col cols="9" md="9">
                        <div class="form-label mb-1" hide-details="auto">
                            {{ $t('message.qualifiedApplicants.dialog.id')}} <strong>*</strong>
                        </div>
                    </v-col>
                    <v-col cols="3" md="3" class="pa-0 mt-2">
                        <v-btn icon class="pl-3"
                            ><v-icon size="16" @click="$emit('remove')"
                                >mdi-delete</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <v-text-field
                    v-model="fix"
                    :rules="[(v) => !!v || 'message.qualifiedApplicants.error.fillStudentID']"
                    dense
                    outlined
                    hide-details="auto"
                    :placeholder="$t('message.qualifiedApplicants.input.pleaseFill')"
                ><template #message="{ message }">
                    {{ $t(message) }}
                </template></v-text-field>
            </v-col>
        </v-row>
        <v-row class="my-0" v-if="select === 'Generate'">
            <v-col cols="4" md="4" class="my-1">
                <div class="form-label mb-1" hide-details="auto">{{ $t('message.qualifiedApplicants.dialog.type')}}</div>
                <v-select
                    v-model="select"
                    dense
                    outlined
                    hide-details="auto"
                    :items="type_gen"
                    @change="select = 'Fix'"
                ></v-select>
            </v-col>
            <v-col cols="4" md="4" class="my-1">
                <div class="form-label mb-1" hide-details="auto" style="width:150px;">
                    {{ $t('message.qualifiedApplicants.dialog.numberDigit')}} <strong>*</strong>
                </div>
                <v-text-field
                    v-model="gen_num"
                    dense
                    outlined
                    :rules="[(v) => !!v || 'message.qualifiedApplicants.error.fillDigit',
                             (v) => !!v && v > 0 || 'message.qualifiedApplicants.error.fillDigit'
                            ]"
                    hide-details="auto"
                    type="number"
                ><template #message="{ message }">
                    {{ $t(message) }}
                </template></v-text-field>
            </v-col>
            <v-col cols="4" md="4" class="my-1">
                <v-row>
                    <v-col cols="8" md="8" class="pr-0">
                        <div class="form-label mb-1" hide-details="auto">
                            {{ $t('message.qualifiedApplicants.dialog.numberStart')}} <strong>*</strong>
                        </div>
                    </v-col>
                    <v-col cols="4" md="4" class="pa-0 mt-2">
                        <v-btn icon
                            ><v-icon size="16" @click="$emit('remove')"
                                >mdi-delete</v-icon
                            ></v-btn
                        >
                    </v-col>
                </v-row>
                <v-text-field
                    v-model="gen_start"
                    :rules="[(v) => !!v || 'message.qualifiedApplicants.error.fillStartNumber',
                             (v) => v.length <= gen_num || 'message.qualifiedApplicants.error.maximumDigit'
                            ]"
                    dense
                    outlined
                    hide-details="auto"
                    type="number"
                ><template #message="{ message }">
                    {{ $t(message) }}
                </template></v-text-field>
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    name: "TypeGen",
    data: () => ({
        fix: "",
        gen_num: 1,
        gen_start: 0,
        select: "Fix",
        type_gen: ["Fix", "Generate"],
        form: false,
    }),
    props: {
        container_id: Number,
    },
    methods: {},
    watch: {
        fix() {
            this.$emit("updateText", this.fix, this.container_id);
        },
        gen_start() {
            this.$emit(
                "updateGenStart",
                this.gen_num,
                this.gen_start,
                this.container_id
            );
        },
        gen_num() {
            this.$emit(
                "updateGenStart",
                this.gen_num,
                this.gen_start,
                this.container_id
            );
        },
    },
};
</script>
